import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default async ({ caseId, input }) => {
	const query = gql`
		mutation addFactToCase($caseId: String!, $input: addFactInput!) {
			addFactToCase(caseId: $caseId, input: $input) {
				status
				errors
				createdStatus {
					id
				}
			}
		}
	`

	const res = await api({
		query,
		variables: {
			caseId,
			input
		}
	})

	return Promise.resolve(res)
}
